import React, { useContext } from 'react';
import PropTypes from 'prop-types';

import Header from './Header';
import Form from 'react-bootstrap/Form';
import Required from './Required';
import LocaleContext from 'constants/localization';

/**
 * Wrapper for fields for supporting multiple values
 * 
 * - allows adding up to maxOccurs constraints
 * - allows removing values
 */
export default function InputWrapper({inputs, error, field}) {
  const { minOccurs, maxOccurs} = field.props;
  const values = field.values;
  const LS = useContext(LocaleContext);

  // Filter undefined / null / objects without value.uri
  const valueCount = values.filter(v =>  {
    if (v && typeof v === 'object') {
      return Boolean(v.uri);
    }
    return Boolean(v);
  }).length;

  const canAdd = maxOccurs > 1 && values.length > 0 && values.length < maxOccurs;
  const canRemove = maxOccurs > 1 && values.length > 1;

  const AddButton = () => canAdd && (
    <button className="value-button" type="button" onClick={() => field.addValue()}>
      {LS.actions.add}
    </button>
  );

  const RemoveButton = ({index}) => canRemove && (
    <button type="button" className="value-button" 
      index={index} onClick={() => field.removeValue(index)}>
      {LS.actions.remove}
    </button>
  );

  return (
    <Form.Group className="field" >
      <Header field={field} />
      {
        inputs.map((input, key) => (
          <div key={key} className='value flex-left'>
            {input}
            <RemoveButton index={key} />
          </div>
        ))
      }
      <Required valueCount={valueCount} minOccurs={minOccurs} error={error}/>
      <AddButton />
    </Form.Group>
  );
}

InputWrapper.propTypes = {
  field: PropTypes.object.isRequired,
  inputs: PropTypes.array.isRequired,
};